module.exports = __webpack_public_path__ + "static/media/green-leafed-trees-2271098.a2b9de77.jpg";